import type { SVGProps } from 'react';
const SvgRemoveDone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#remove_done_svg__a)">
      <path
        fill="currentColor"
        d="m1.79 12 5.58 5.59L5.96 19 .37 13.41 1.79 12Zm.45-7.78L12.9 14.89l-1.28 1.28L7.44 12l-1.41 1.41L11.62 19l2.69-2.69 4.89 4.89 1.41-1.41L3.65 2.81 2.24 4.22Zm14.9 9.27L23.62 7 22.2 5.59l-6.48 6.48 1.42 1.42ZM17.96 7l-1.41-1.41-3.65 3.66 1.41 1.41L17.96 7Z"
      />
    </g>
    <defs>
      <clipPath id="remove_done_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRemoveDone;
